import { UserType } from "@src/types.generated";
import useUser from "./useUser";

const useIsFullAdmin = (): boolean => {
  const { user } = useUser();
  return user?.userType === UserType.Admin;
};

export default useIsFullAdmin;
